//#region IMPORT
import React from 'react';
import { Box, Stack } from '@mui/material';
import M_FILE_BASIC_01F from '../M_FILE_BASIC_01/M_FILE_BASIC_01F';
import M_FILE_BASIC_02F from '../M_FILE_BASIC_02/M_FILE_BASIC_02F';
import M_FILE_BASIC_03F from '../M_FILE_BASIC_03/M_FILE_BASIC_03F';
//#endregion

function M_FILE_BASIC(props) {
  //#region 변수
  const components = [
    // 교육 자료
    <M_FILE_BASIC_01F userInfo={props.userInfo} />,
    // 작업계획서
    <M_FILE_BASIC_02F userInfo={props.userInfo} />,
    // 작업허가서
    <M_FILE_BASIC_03F userInfo={props.userInfo} />,
  ];
  //#endregion

  return (
    <Box
      sx={{
        height: '100%',
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '18px',
        fontWeight: 'bold',
        overflow: 'hidden',
        gap: '16px',
      }}
    >
      <Stack sx={{ width: '100%', height: '100%' }}>
        {components[props.activeStep] || null}
      </Stack>
    </Box>
  );
}

export default M_FILE_BASIC;
